var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_53101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73014 20.165C6.73014 22.019 5.23177 23.5175 3.37777 23.5175C1.52377 23.5175 0.0253906 22.019 0.0253906 20.165C0.0253906 18.3111 1.52377 16.8127 3.37789 16.8127H6.73002V20.1651L6.73014 20.165ZM8.40639 20.165C8.40639 18.3111 9.90476 16.8127 11.7588 16.8127C13.6128 16.8127 15.1111 18.3111 15.1111 20.1651V28.546C15.1111 30.4 13.6128 31.8985 11.7586 31.8985C9.90489 31.8985 8.40639 30.4 8.40639 28.546V20.1651V20.165Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7587 6.70475C9.90475 6.70475 8.40625 5.20638 8.40625 3.35238C8.40625 1.49838 9.90487 0 11.7587 0C13.6126 0 15.1111 1.49838 15.1111 3.35238V6.70487H11.7586L11.7587 6.70475ZM11.7587 8.40637C13.6127 8.40637 15.1111 9.90475 15.1111 11.7587C15.1111 13.6127 13.6128 15.1111 11.7586 15.1111H3.3525C1.49837 15.1111 0 13.6128 0 11.7586C0 9.90488 1.49838 8.40637 3.35238 8.40637H11.7586H11.7587Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1937 11.7587C25.1937 9.90475 26.6921 8.40625 28.546 8.40625C30.4 8.40625 31.8985 9.90475 31.8985 11.7587C31.8985 13.6127 30.4 15.1111 28.546 15.1111H25.1937V11.7586V11.7587ZM23.5175 11.7587C23.5175 13.6127 22.019 15.1111 20.165 15.1111C18.3111 15.1111 16.8127 13.6128 16.8127 11.7586V3.3525C16.8127 1.49837 18.3111 0 20.165 0C22.0189 0 23.5174 1.49838 23.5174 3.35238V11.7586L23.5175 11.7587Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.165 25.1937C22.019 25.1937 23.5175 26.6921 23.5175 28.546C23.5175 30.4 22.019 31.8985 20.165 31.8985C18.3111 31.8985 16.8127 30.4 16.8127 28.546V25.1937H20.1651H20.165ZM20.165 23.5175C18.3111 23.5175 16.8127 22.019 16.8127 20.165C16.8127 18.3111 18.3111 16.8127 20.1651 16.8127H28.5714C30.4254 16.8127 31.9239 18.3111 31.9239 20.1651C31.9239 22.019 30.4254 23.5175 28.5714 23.5175H20.1651H20.165Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_53101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.989dff70e1fb316f8e997cca07acaf70.svg";
export { ForwardRef as ReactComponent };